import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useLanguage } from '../../context/LanguageContext';

export function UserEditDialog({ open, onOpenChange, formData, setFormData, onSubmit }) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('admin_users_edit')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>{t('name')}</Label>
            <Input value={formData.full_name} onChange={(e) => setFormData({...formData, full_name: e.target.value})} data-testid="edit-fullname-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('email')}</Label>
            <Input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} data-testid="edit-email-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('phone')}</Label>
            <Input value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} data-testid="edit-phone-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('profile_kyc_status_label')}</Label>
            <Select value={formData.kyc_status} onValueChange={(value) => setFormData({...formData, kyc_status: value})}>
              <SelectTrigger data-testid="edit-kyc-status-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="pending">{t('status_pending')}</SelectItem>
                <SelectItem value="submitted">{t('submitted')}</SelectItem>
                <SelectItem value="approved">{t('approved')}</SelectItem>
                <SelectItem value="rejected">{t('rejected')}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>{t('admin_users_role')}</Label>
            <Select value={formData.role} onValueChange={(value) => setFormData({...formData, role: value})}>
              <SelectTrigger data-testid="edit-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="user">{t('admin_users_role_user')}</SelectItem>
                <SelectItem value="admin">{t('admin_users_role_admin')}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>{t('admin_users_status')}</Label>
            <Select value={formData.account_status} onValueChange={(value) => setFormData({...formData, account_status: value})}>
              <SelectTrigger data-testid="edit-account-status-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="active">{t('status_active')}</SelectItem>
                <SelectItem value="suspended">{t('status_suspended')}</SelectItem>
                <SelectItem value="restricted">{t('status_frozen')}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>{t('password')}</Label>
            <Input type="password" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} placeholder={t('admin_users_password_placeholder')} data-testid="edit-password-input" />
            <p className="text-xs text-muted-foreground">{t('admin_users_password_hint')}</p>
          </div>
          <div className="space-y-2">
            <Label>{t('admin_users_transfer_limit')}</Label>
            <Input type="number" value={formData.transfer_limit} onChange={(e) => setFormData({...formData, transfer_limit: e.target.value})} placeholder={t('admin_users_transfer_limit_placeholder')} data-testid="edit-transfer-limit-input" />
            <p className="text-xs text-muted-foreground">{t('admin_users_transfer_limit_hint')}</p>
          </div>
          <Button className="w-full" onClick={onSubmit} data-testid="update-user-button">{t('update')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
